import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    justifyContent: "space-between",
  },
  qrCode: {
    marginVertical: 16,
    alignSelf: "center",
  },
  qrCodeContainer: {
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: 15,
    paddingBottom: 15
  },
  spaceBetween: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  textBold: {
    fontWeight: "bold",
    fontSize: 16
  },
  copyText: {
    color: "#256df4",
    fontSize: 16
  },
  txIdInput: {
    marginTop: 12,
  },

  modal: {
    margin: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    flex: 1,
    padding: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  modalClose: {
    position: "absolute",
    top: 16,
    left: 16,
  },
  modalSuccess: {
    width: 80,
    height: 80,
    marginBottom: 32,
  },
  modalText: {
    textAlign: "center",
  },
  modalImage: {
    position: "absolute",
    width: 120,
    height: 120,
    right: 0,
    top: "80%",
  },
  contentText: {
    fontSize: 16
  }
});
